export enum DateDisplayType {
  shortDate,
  shortTime,
  shortDateShortTime,
  shortDateLongTime,
}
